import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Container } from '@pixi/react';
import { Scrollbox } from 'pixi-scrollbox';

function ScrollBox({
  boxWidth,
  boxHeight,
  scrollHeight,
  content,
  x = 0,
  y = 0,
  scrollBarX = 800,
  scrollBarY,
  maxScrollBarY,
}) {
  const ref = useRef();

  const scrollBox = useMemo(
    () =>
      new Scrollbox({
        boxWidth,
        boxHeight: boxHeight,
        overflowY: 'scroll',
        overflowX: 'hidden',
        scrollbarSize: 10,
        scrollbarOffsetVertical: 5,
        scrollbarBackgroundAlpha: 0,
      }),
    [boxWidth, boxHeight]
  );

  const handleScrollBar = useCallback(() => {
    const { scrollbar } = scrollBox;
    scrollbar.interactive = false;
    scrollbar.clear();

    const scrollPercent =
      scrollBox.scrollTop / (scrollBox.content.height - scrollBox.options.boxHeight);
    const maxScroll = scrollBox.options.boxHeight - maxScrollBarY;
    const currentPosition = scrollPercent * maxScroll;
    scrollbar.beginFill(0xffffff, 0.5);
    scrollbar.drawRoundedRect(scrollBarX, currentPosition - scrollBarY, 6, 60, 20);
    scrollBox.content.x = 0;
  }, [scrollBox, scrollBarX, scrollBarY, maxScrollBarY]);

  useEffect(() => {
    if (ref.current) {
      content.forEach((element) => {
        scrollBox.content.addChild(element);
      });
      scrollBox.content.screenHeight = scrollHeight;
      scrollBox.content.addEventListener('moved', handleScrollBar);
      scrollBox.update();
      handleScrollBar();
      ref.current.addChild(scrollBox);
    }
  }, [ref, scrollBox, content, handleScrollBar, scrollHeight]);

  return <Container ref={ref} x={x} y={y} />;
}

export default ScrollBox;
